export default {
    create_edit_dashboard_new: "Crear panel de control",
    create_edit_dashboard_edit: "Editar el panel de control",
    create_edit_dashboard_name: "Nombre del panel de control",
    create_edit_dashboard_label: "Panel de Control",
    create_edit_dashboard_create_success_message: "Se ha creado el panel de control",
    create_edit_dashboard_edit_success_message: "El panel de control ha sido editado",
}